module.exports = __webpack_public_path__ + "static/logo-nci-itcr-2ac7557bebea39bc33a50cf4cd12b64f.png";